import { useEffect, useState } from 'react';
import { WindowLoader } from 'medere-ui-framework';
import { useHealthCheckService } from '../../servicesHooks/HealthCheck/useHealthCheckService';

export default function VaadinView({ route, name }: Readonly<{ route: string, name: string }>) {
  const { healthcheck } = useHealthCheckService();
  const [ready, setReady] = useState<boolean>(false);

  useEffect(() => {
    setReady(false);
    healthcheck().finally(() => setReady(true));
  }, [route, name]);

  if (!ready) {
    return (
      <div className="flex justify-content-center align-items-center h-screen w-screen">
        <WindowLoader showLoader />
      </div>);
  }

  return (
    <div className='viewContainer' style={{ height: '100%', overflow: 'hidden' }}>
      <iframe
        src={`/vaadinapp/#!${route}`}
        style={{ width: '100%', height: '100%', border: 'none' }}
        title={name} />
    </div>);
};